import { TradingTerminalContext } from "@shared/features/tradingTerminal/TradingTerminal.context";
import { OrderTypes } from "@shared/features/trades/common/types";
import { useContext } from "react";
import { ConfigurationItem } from "@shared/types";

const useSharedTradeGeneralConfiguration = (orderType: OrderTypes) => {
  const {
    useTradingTerminalOldVersion,
    getCreateTradeGeneralDataQuery,
    getSignalCreateGeneralDataQuery,
  } = useContext(TradingTerminalContext)!;
  const generalOrdersData =
    getCreateTradeGeneralDataQuery.currentData?.data.orders ??
    getSignalCreateGeneralDataQuery.currentData?.data.targets;

  let generalOrdersDataStrategy: ConfigurationItem | undefined;
  if (orderType === OrderTypes.ENTRY) {
    generalOrdersDataStrategy = generalOrdersData?.buying_strategy;
  } else if (orderType === OrderTypes.TAKE_PROFIT) {
    generalOrdersDataStrategy = generalOrdersData?.selling_strategy;
  }

  return {
    generalOrdersData,
    generalOrdersDataStrategy,
    useTradingTerminalOldVersion,
  };
};

export default useSharedTradeGeneralConfiguration;
